class SingleSeriesLanding extends HTMLElement {
  connectedCallback() {
    this.variantSelect = this.querySelector('[data-series-variant-select]');
    this.variantId = this.querySelector('[data-series-variant-id]');
    this.price = this.querySelector('[data-series-price]');
    this.comparePrice = this.querySelector('[data-series-compare-price]');
    this.addButton = this.querySelector('[data-series-add-button]');
    this.mainImage = this.querySelector('[data-series-main-image]');

    this.variantSelect?.addEventListener('change', () => this.updateVariant());

    this.querySelectorAll('[data-series-thumbnail]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => this.updateImage(thumbnail));
    });
  }

  updateVariant() {
    const option = this.variantSelect.options[this.variantSelect.selectedIndex];
    if (!option) return;

    this.variantId.value = option.value;
    this.price.textContent = option.dataset.price;

    if (option.dataset.comparePrice) {
      this.comparePrice.textContent = option.dataset.comparePrice;
      this.comparePrice.hidden = false;
    } else {
      this.comparePrice.textContent = '';
      this.comparePrice.hidden = true;
    }

    const available = option.dataset.available === 'true';
    this.addButton.disabled = !available;
    this.addButton.textContent = available
      ? this.addButton.dataset.availableLabel
      : this.addButton.dataset.soldOutLabel;

    if (option.dataset.image) {
      this.updateMainImage(option.dataset.image, option.dataset.imageAlt || '');
    }
  }

  updateImage(thumbnail) {
    this.updateMainImage(thumbnail.dataset.image, thumbnail.dataset.imageAlt || '');
    this.querySelectorAll('[data-series-thumbnail]').forEach((item) => {
      item.setAttribute('aria-current', String(item === thumbnail));
    });
  }

  updateMainImage(source, alt) {
    if (!this.mainImage || !source) return;
    this.mainImage.src = source;
    this.mainImage.removeAttribute('srcset');
    this.mainImage.alt = alt;
  }
}

if (!customElements.get('single-series-landing')) {
  customElements.define('single-series-landing', SingleSeriesLanding);
}
